import React, { useState, useMemo, useCallback, useRef, FC } from "react"
import { Element, Node, Transforms, createEditor, Editor, Path } from "slate"
import {
  Slate,
  Editable,
  useEditor,
  useSelected,
  useFocused,
  withReact,
  ReactEditor,
  RenderElementProps
} from "slate-react"
import { withHistory } from "slate-history"
import { useDrag, useDrop, DndProvider } from "react-dnd"
import Backend from "react-dnd-html5-backend"
import { EditorElement } from "./EditorElement"
import { GooglePhotoPicker } from "./GooglePhotoPicker"
import { GooglePickerResult } from "../../libs/GooglePickerResult"
import { loadByMock } from "../../data/googlePickedMockData/GooglePickedMockData"
import { transfromToPhotos } from "../../libs/GooglePicker"
import { withImages, insertImages } from "../../libs/EditorImages"
import { sleep } from "../../libs/utils"

type PhotoEditorProps = {
  initData: Node[]
}

let loaded = false
export const PhotoEditor: FC<PhotoEditorProps> = ({ initData }) => {
  const [nodes, setNodes] = useState(initData)
  const editor = useMemo(
    () => withImages(withHistory(withReact(createEditor()))),
    []
  )

  const handlePickupPhotos = (result: GooglePickerResult) => {
    insertImages(editor, transfromToPhotos(result))
  }

  if (!loaded) {
    loaded = true
    ;(async () => {
      await sleep(0.1)
      console.log("once")
      const result = await loadByMock("_6mai")
      insertImages(
        editor,
        result.map(p => p.entity)
      )
    })()
  }

  return (
    <DndProvider backend={Backend}>
      <Slate
        editor={editor}
        value={nodes}
        onChange={changedNodes => {
          setNodes(changedNodes)
        }}
      >
        <Editable
          spellCheck={false}
          renderElement={props => <EditorElement {...props} />}
          placeholder="---"
        />
      </Slate>
      <GooglePhotoPicker onPickPhotos={handlePickupPhotos} />
    </DndProvider>
  )
}
